import axios from 'axios';
import {MessageBox, Message} from 'element-ui';

// create an axios instance

const service = axios.create({
  // baseURL: settings.apiBaseUrl, // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  timeout: 60000 // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    // do something before request is sent
    return config;
  },
  error => {
    // do something with request error
    return Promise.reject(error);
  }
);

// response interceptor
service.interceptors.response.use(

  response => {
    const res = response.data;
    if (response.data.code == 403) {
      Message({
        message: "无权限访问。",
        type: 'error',
        duration: 60 * 1000
      });


      history.go(-1)
      return Promise.reject("无权限访问。");
    }
    return res;
  },
  error => {

    if(error.response && error.response.data) {
      let msg = '状态码：' + error.response.data.status +"<br><br> error:"+error.response.data.error
        +'<br> <br> message: '+ error.response.data.message ;

      Message({
        dangerouslyUseHTMLString: true,
        message: msg,
        type: 'error',
        duration: 15 * 1000
      });
    }

    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/common/utils/request.js